import {action} from "mobx";
import walletService from "../services/walletService";
import appStore from "./appStore";

class walletStore {
    @action createAndActivateCourierWallet = async params => {
        const resultOfRequest = await walletService.createAndActivateCourierWallet(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getDailyTransactionsSummary = async params => {
        const resultOfRequest = await walletService.getDailyTransactionsSummary(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourierWalletWithDailyTransactionsSummary = async params => {
        const resultOfRequest = await walletService.getCourierWalletWithDailyTransactionsSummary(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getDailyTransactions = async params => {
        const resultOfRequest = await walletService.getDailyTransactions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourierCreditLogSummary = async params => {
        const resultOfRequest = await walletService.getCourierCreditLogSummary(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourierPaymentInvoices = async params => {
        const resultOfRequest = await walletService.getCourierPaymentInvoices(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourierWalletPayments = async params => {
        const resultOfRequest = await walletService.getCourierWalletPayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action listWalletCouriers = async params => {
        const resultOfRequest = await walletService.listWalletCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action blockWithdrawAction = async params => {
        const resultOfRequest = await walletService.blockWithdrawAction(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action unblockWithdrawAction = async params => {
        const resultOfRequest = await walletService.unblockWithdrawAction(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getWalletInvoiceVendors = async params => {
        const resultOfRequest = await walletService.getWalletInvoiceVendors(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
    @action listWalletCourierFinancials = async params => {
        const resultOfRequest = await walletService.listWalletCourierFinancials(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action uploadWalletCourierFinancialFile = async params => {
        const resultOfRequest = await walletService.uploadWalletCourierFinancialFile(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
        }
        return {
            data: resultOfRequest.data.result || resultOfRequest.data
        };
    };

    @action async listUploadTypes() {
        const resultOfRequest = await walletService.listUploadTypes();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
        }
        return resultOfRequest.data;
    }

    @action async getCourierFinancialUploadsTemplate() {
        const resultOfRequest = await walletService.getCourierFinancialUploadsTemplate();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
        }
        return resultOfRequest.data;
    }

    @action async createFinancialUploadExcelToSpecificCourier(params) {
        const resultOfRequest = await walletService.createFinancialUploadExcelToSpecificCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
        }
        return resultOfRequest.data;
    }

    @action async generateWithdrawSummary(params) {
        const resultOfRequest = await walletService.generateWithdrawSummary(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
        }
        return resultOfRequest.data;
    }

    @action async approveWithdraw(params) {
        const resultOfRequest = await walletService.approveWithdraw(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
        }
        return resultOfRequest.data;
    }
}

export default new walletStore();
